import { render, staticRenderFns } from "./ownerDetailAppUser.vue?vue&type=template&id=4b4c4504"
import script from "./ownerDetailAppUser.vue?vue&type=script&lang=js"
export * from "./ownerDetailAppUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports